import React from 'react';
import Icon from '../../../components/AppIcon';

const ValidationStatsCard = ({ stats }) => {
  const statItems = [
    {
      label: 'Today\'s Entries',
      value: stats?.todayEntries,
      icon: 'Package',
      color: 'primary',
      trend: stats?.todayTrend
    },
    {
      label: 'Validated',
      value: stats?.validated,
      icon: 'CheckCircle2',
      color: 'success',
      percentage: stats?.validatedPercentage
    },
    {
      label: 'Duplicates Found',
      value: stats?.duplicates,
      icon: 'AlertTriangle',
      color: 'warning',
      percentage: stats?.duplicatesPercentage
    },
    {
      label: 'Avg. Processing Time',
      value: stats?.avgProcessingTime,
      icon: 'Clock',
      color: 'secondary',
      unit: 'sec'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-18 md:gap-24">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-elevation-1 border border-border p-24 hover:shadow-elevation-2 transition-smooth"
        >
          <div className="flex items-start justify-between mb-18">
            <div className={`w-[44px] h-[44px] bg-${item?.color}/10 rounded-lg flex items-center justify-center`}>
              <Icon
                name={item?.icon}
                size={22}
                color={`var(--color-${item?.color})`}
                strokeWidth={2}
              />
            </div>
            {item?.trend && (
              <div className={`flex items-center gap-4 px-8 py-4 rounded-lg ${item?.trend > 0 ? 'bg-success/10' : 'bg-error/10'}`}>
                <Icon
                  name={item?.trend > 0 ? 'TrendingUp' : 'TrendingDown'}
                  size={14}
                  color={`var(--color-${item?.trend > 0 ? 'success' : 'error'})`}
                  strokeWidth={2}
                />
                <span className={`font-caption text-xs font-medium ${item?.trend > 0 ? 'text-success' : 'text-error'}`}>
                  {Math.abs(item?.trend)}%
                </span>
              </div>
            )}
          </div>

          <div className="space-y-6">
            <div className="flex items-baseline gap-8">
              <span className="font-heading font-bold text-2xl md:text-3xl text-foreground">
                {item?.value}
              </span>
              {item?.unit && (
                <span className="font-caption text-sm text-muted-foreground">
                  {item?.unit}
                </span>
              )}
            </div>
            <p className="font-body text-xs md:text-sm text-muted-foreground">
              {item?.label}
            </p>
            {item?.percentage !== undefined && (
              <div className="flex items-center gap-8 mt-12">
                <div className="flex-1 h-[6px] bg-muted rounded-full overflow-hidden">
                  <div
                    className={`h-full bg-${item?.color} rounded-full transition-smooth`}
                    style={{ width: `${item?.percentage}%` }}
                  />
                </div>
                <span className="font-caption text-xs text-muted-foreground font-medium">
                  {item?.percentage}%
                </span>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ValidationStatsCard;